import React from 'react';
import { Accordion, Card, Col, Row } from 'react-bootstrap';

const CustomFieldsInfo = ({ activeAccordion, activeKey, extraFieldsAttributes, customFields }) => {
  if (!extraFieldsAttributes || extraFieldsAttributes.length === 0) {
    return null;
  }

  const getFieldDisplayValue = (customField, extraField) => {
    if (!extraField) return null;

    if (customField.field_type === 'boolean') {
      return extraField.value === '1' ? 'Sí' : 'No';
    }
    if (customField.field_type === 'selector') {
      const matchingAttribute = customField.custom_field_types_attributes.find(e => String(e.id) === extraField.value);
      return matchingAttribute ? matchingAttribute.name : null;
    }

    return extraField.value;
  };

  const getExtraFieldForCustomField = customField => {
    return extraFieldsAttributes.find(field => field.customFieldId === customField.id);
  };

  const groupFieldsInRows = fields => {
    const activeFields = fields.filter(field => field.active);
    const rows = [];
    for (let i = 0; i < activeFields.length; i += 3) {
      rows.push(activeFields.slice(i, i + 3));
    }
    return rows;
  };

  const fieldRows = groupFieldsInRows(customFields);

  return (
    <Card className="mr-2">
      <Col className={`${activeKey === 'custom-fields' ? 'top-header-green' : 'top-header-light-gray'} br-5`}>
        <Accordion.Toggle
          as={Col}
          eventKey="6"
          className="card-header-title"
          onClick={activeAccordion}
          style={{ textAlign: 'right' }}
        >
          Campos Personalizados
        </Accordion.Toggle>
      </Col>
      <Accordion.Collapse eventKey="6">
        <Card.Body className="personal-data">
          {fieldRows.map(row => {
            const rowKey = row.map(f => f.id).join('-');
            const placeholders = ['first', 'second', 'third'];
            const needed = 3 - row.length;

            return (
              <Row className="mt-3" key={rowKey}>
                {row.map(customField => {
                  const extraField = getExtraFieldForCustomField(customField);
                  const displayValue = getFieldDisplayValue(customField, extraField);
                  return (
                    <Col md={4} className="col-md-4" key={customField.id}>
                      <div className="d-flex flex-column mb-3">
                        <span className="type">{customField.name}:</span>
                        <span className={`answer ${!displayValue ? 'text-grey' : ''}`}>
                          {displayValue || 'No Aplica'}
                        </span>
                      </div>
                    </Col>
                  );
                })}

                {placeholders.slice(0, needed).map(name => (
                  <Col md={4} className="col-md-4" key={`${rowKey}-${name}-placeholder`} />
                ))}
              </Row>
            );
          })}
        </Card.Body>
      </Accordion.Collapse>
    </Card>
  );
};

export default CustomFieldsInfo;
